import * as React from 'react';
import { useSelector } from 'react-redux';
import { Avatar, Text, cn, getTime, scrollToElement } from '@siteground/styleguide';
import { getChatSettings } from '../../../selectors/chat';
import { parseOperatorMessage } from '../../../utils/parse-message';
import { ChatContext } from '../../chat-context';
import './operator-message.css';

const OperatorMessage = ({ message, translatedMessage, operator, timestamp, className }) => {
  const domRef = React.useRef(null);
  const { shouldAutoScroll } = React.useContext(ChatContext);

  const { translate } = useSelector(getChatSettings);

  const time = getTime(timestamp);
  const messageToUse = translate ? translatedMessage || message : message;

  const classes = cn('sg-operator-message', className);

  React.useEffect(() => {
    if (shouldAutoScroll) {
      scrollToElement(domRef.current, { behavior: 'auto', block: 'start', inline: 'nearest' });
    }
  }, []);

  const { first_name, last_name, avatar } = operator;

  return (
    <div ref={domRef} className={classes}>
      <div className="sg-operator-message__avatar">
        <Avatar firstName={first_name} lastName={last_name} src={avatar} size="32" />
      </div>

      <div className="sg-operator-message__text">
        <Text color="dark">{parseOperatorMessage(messageToUse)}</Text>

        <Text align="right" color="typography-disabled" size="small">
          {time}
        </Text>
      </div>
    </div>
  );
};

export default OperatorMessage;
